/**
 * STEMO: Stay on product page after add-to-cart.
 * Updates cart count silently — no redirect, no drawer/popover auto-open.
 */
(function () {
  document.addEventListener(
    "variant:add",
    (event) => {
      if (event.detail) {
        event.detail.blockCartDrawerOpening = true;
      }
    },
    true
  );
})();
